var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crl-link",class:{ disabled: _vm.disabled },on:{"click":_vm.clickAction}},[_vm._v(" "+_vm._s(_vm.caption)+" "),_c('img',{staticClass:"crll-img",attrs:{"src":_vm.EXTERNALICON,"alt":"externalicon"}})])}
var staticRenderFns = []

export { render, staticRenderFns }